// Google Analytics yardımcıları. Etiket public/index.html'de yüklenir (çerez izni verilene kadar
// analiz depolaması kapalı). Rapor sayfaları (/r/...) ölçülmez. Sayfa adresi olarak yalnızca yol
// gönderilir; sorgu parametreleri (token, plan vb.) GA'ya gitmez.

type GtagFn = (...args: unknown[]) => void;
const gtag = (): GtagFn | null => (typeof window !== 'undefined' && typeof (window as any).gtag === 'function' ? (window as any).gtag : null);

let granted = false;
// Üye olan / giriş yapan kullanıcı Kullanım Koşulları'nı kabul etmiş sayılır (ayrı çerez bandı yok).
export function grantAnalytics() {
  const g = gtag();
  if (!g || granted) return;
  granted = true;
  g('consent', 'update', { analytics_storage: 'granted' });
}

export function track(event: string, params: Record<string, unknown> = {}) {
  const g = gtag();
  if (!g || window.location.pathname.startsWith('/r/')) return;
  try { if (localStorage.getItem('poyais_token')) grantAnalytics(); } catch { /* yoksay */ }
  g('event', event, { transport_type: 'beacon', ...params });
}

// Her olay yalnızca bir kez gönderilsin (sayfa yenilenince ödeme dönüşü tekrar sayılmasın).
export function trackOnce(key: string, event: string, params: Record<string, unknown> = {}) {
  try {
    if (sessionStorage.getItem(`ga_once_${key}`)) return;
    sessionStorage.setItem(`ga_once_${key}`, '1');
  } catch { /* depolama kapalıysa yine de gönder */ }
  track(event, params);
}

let started = false;
// SPA: ilk yüklemede ve her yol değişiminde page_view gönderir.
export function startPageViews() {
  if (started || typeof window === 'undefined') return;
  started = true;
  let last = '';
  const send = () => {
    const path = window.location.pathname;
    if (path === last) return;
    last = path;
    track('page_view', { page_path: path, page_location: window.location.origin + path, page_title: document.title });
  };
  const wrap = (m: 'pushState' | 'replaceState') => {
    const orig = window.history[m];
    window.history[m] = function (this: History, ...a: Parameters<History['pushState']>) { const r = orig.apply(this, a); setTimeout(send, 0); return r; } as typeof window.history.pushState;
  };
  wrap('pushState'); wrap('replaceState');
  window.addEventListener('popstate', send);
  send();
}
